export type Highlight = {
  headline: string;
  description: string;
};

export type LocaleContent = {
  highlights: [Highlight, Highlight, Highlight];
  cooperationLabel: string;
  learnMoreQuestion: string;
  demoLinkText: string;
};

// Öffentlicher Share-Link des Demo-Albums (kein Geheimnis)
export const demoAlbumUrl =
  'https://app.fotofunken.de/share/XR3eq_DRBV3BZ5S5W38FHdoUmhC18xVpWliSFiVEATk_uixZH4UW36EMY90jeip9gbc';

export const marketingContent: { de: LocaleContent; en: LocaleContent } = {
  de: {
    highlights: [
      {
        headline: 'Nur E-Mail nötig',
        description: 'Kein langes Formular, keine Kreditkarte — Anmeldung in Sekunden.',
      },
      {
        headline: 'Keine App nötig',
        description: 'Gäste laden per QR-Code direkt hoch — kein Download, kein Konto.',
      },
      { headline: 'In 3 Minuten live', description: 'Album erstellen, QR-Code teilen, fertig.' },
    ],
    cooperationLabel: 'In Kooperation mit',
    learnMoreQuestion: 'Mehr erfahren?',
    demoLinkText: 'Demo ansehen',
  },
  en: {
    highlights: [
      { headline: 'Email only', description: 'No long form, no credit card — sign up in seconds.' },
      {
        headline: 'No app needed',
        description: 'Guests upload directly via QR code — no download, no account.',
      },
      { headline: 'Live in 3 minutes', description: 'Create an album, share the QR code, done.' },
    ],
    cooperationLabel: 'In cooperation with',
    learnMoreQuestion: 'Want to learn more?',
    demoLinkText: 'View the demo',
  },
};
